<template>
  <v-row no-gutters>
    <UploadDialog
      ref="dialog"
      :payload-only="payloadOnly"
      :return-file-only="returnFileOnly"
      :multiple="multiple"
      :file-type="fileType"
      :value="files"
      @change="updateFiles"
    />
    <v-col cols="auto" :class="isReversed ? 'd-flex flex-column-reverse' : ''">
      <v-row>
        <v-col>
          <div>{{ label === undefined || label === null ? 'Медиа-файлы' : label }}</div>
          <v-btn
            class="ma-2"
            x-small
            color="primary"
            outlined
            @click.stop="$refs.dialog.open()"
          >
            {{ buttonName || 'Загрузить...' }}
          </v-btn>
        </v-col>
      </v-row>
      <MediaFilePreview
        v-for="fileId in files"
        :key="fileId"
        description
        is-chosen
        :hide-delete="hideDelete"
        :value="fileId"
        :caption="caption"
        @change="updateFiles"
      />
      <slot name="preview-bottom" />
      <v-row v-if="isShowCaption">
        <v-col>
          <span>Заголовок</span>
          <v-text-field
            outlined
            dense
            class="mt-0 pt-0"
            :value="caption"
            @change="$emit('change-caption', $event)"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import UploadDialog from './upload-dialog'
import MediaFilePreview from '@/components/media-file-preview'
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'

export default {
  name: 'MediaFilePicker',
  components: {
    UploadDialog,
    MediaFilePreview
  },
  props: {
    value: {
      type: [Array, Number],
      default: null
    },
    fileType: {
      type: Object,
      default: () => mediaTypesByKeys().ALL
    },
    label: {
      type: String,
      default: null
    },
    buttonName: {
      type: String,
      default: null
    },
    multiple: {
      type: Boolean,
      default: true
    },
    isReversed: {
      type: Boolean,
      default: false
    },
    payloadOnly: {
      type: Boolean,
      default: false
    },
    returnFileOnly: {
      type: Boolean,
      default: false
    },
    hideDelete: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    isShowCaption: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    files () {
      const val = this.value
      if (this.multiple && Array.isArray(val)) return val
      else return [val]
    }
  },
  methods: {
    updateFiles (value) {
      let payload = {}
      if (this.files.includes(value)) {
        if (this.multiple) payload = this.files.filter(fileId => fileId !== value)
        else payload = null
      } else {
        if (this.multiple) payload = [...this.files, value]
        else payload = value
      }
      this.$emit('change', payload)
    }
  },
  mounted () {
    if (this.multiple && !Array.isArray(this.value) && this.value !== null) {
      throw new Error('prop "value" should be "Array" type if picker is "multiple"!')
    } else if (!this.multiple && typeof this.value !== 'number' && this.value !== null) {
      throw new Error('prop "value" should be "Number" type if picker is NOT "multiple"!')
    }
  }
}
</script>
